import styled from 'styled-components';
import { space, color, typography, layout, flexbox, grid, background, border, position, shadow } from 'styled-system';
import sx from '../sx.js';

/**
 * @deprecated The Box component is deprecated. Replace with a `div` or
 * appropriate HTML element instead, with CSS modules for styling.
 * @see https://github.com/primer/react/blob/main/contributor-docs/migration-from-box.md
 */
const Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "sc-62in7e-0"
})(space, color, typography, layout, flexbox, grid, background, border, position, shadow, sx);

export { Box, Box as default };
